import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { Subscription } from 'rxjs';
import { AB_SENTOO } from '../../../../shared/constants';
import { SentooService } from '../../../services/sentoo.service';
import { PaymentStatus } from '../../../services/status.service';

@Component({
  selector: 'ab-sentoo-transfer',
  templateUrl: './sentoo-transfer.component.html',
  styleUrls: ['./sentoo-transfer.component.scss']
})
export class SentooTransferComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  @ViewChild('qrCodeImage') qrCodeImage: ElementRef;
  @ViewChild('sentooPaymentToken') sentooPaymentToken: TemplateRef<any>;

  public paymentStatus: PaymentStatus = 'paying';
  public merchantInfo: any;
  public isLoading = false;
  public searchParams: any = undefined;
  public returnUrl: string;
  private subscription: Subscription;

  constructor(
    private sentooService: SentooService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.searchParams = new URLSearchParams();
      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          this.searchParams.set(key, params[key]);
        }
      }
      if (this.searchParams) {
        this.sentooService.setEncryptedData(this.searchParams.toString());
      } else {
        this.paymentStatus = 'invalid';
      }
    });
  }

  setPaymentStatus(paymentStatus) {
    this.paymentStatus = paymentStatus;
  }

  setMerchantInfo(merchantInfo) {
    this.merchantInfo = merchantInfo;
    if (this.merchantInfo.numberOfApprovalsRemaining > 0) {
      this.paymentStatus = 'pending';
    } else {
      this.paymentStatus = 'complete';
    }
  }

  setCancelReturnUrl(url) {
    this.returnUrl = url;
  }

  resetPayment() {
    const sentooTransaction = this.searchParams?.get('sentoo-transaction');
    const country = this.searchParams?.get('country');

    this.router.navigate([AB_SENTOO], {
      queryParams: {
        country,
        'sentoo-transaction': sentooTransaction
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
